/* ALON Studio — small interactions (see assets/alon-studio.css).
   Deliberately quiet, no libraries:
   - content below the fold fades up softly once as it arrives
   - the header gets a light frosted background once the page scrolls
   - the packs menu photo follows the row being pointed at or focused
   - buttons give a small press; the cart count pops when it changes
   Reduced motion: content is shown as-is and nothing moves. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = 'animate' in Element.prototype;
  var vh = window.innerHeight;
  var tasks = [];

  function onFrame(fn) { tasks.push(fn); }

  /* ---------- Header background once scrolled ---------- */
  function initHeader() {
    var header = document.querySelector('.av-hdr');
    if (!header) return;
    onFrame(function (y) { header.classList.toggle('st-hdr-scrolled', y > 10); });
  }

  /* ---------- Packs menu: the photo follows the row ---------- */
  function initPacks() {
    document.querySelectorAll('[data-st-packs]').forEach(function (el) {
      var rows = Array.prototype.slice.call(el.querySelectorAll('[data-st-pack-row]'));
      var imgs = Array.prototype.slice.call(el.querySelectorAll('[data-st-pack-img]'));
      if (!rows.length) return;
      function setActive(n) {
        rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-st-pack-row') === n); });
        imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-st-pack-img') === n); });
      }
      setActive(rows[0].getAttribute('data-st-pack-row'));
      rows.forEach(function (row) {
        var n = row.getAttribute('data-st-pack-row');
        row.addEventListener('pointerenter', function () { setActive(n); });
        row.addEventListener('focusin', function () { setActive(n); });
      });
    });
  }

  /* ---------- Soft arrival ---------- */
  function initReveals() {
    if (reduce || (window.Shopify && window.Shopify.designMode) || !doc.classList.contains('av-motion')) return;
    var items = [];
    function add(el) {
      if (el.classList.contains('st-pre')) return;
      if (el.getBoundingClientRect().top < vh * 0.96) return; // visible at load: leave it be
      el.classList.add('st-pre');
      items.push(el);
    }
    document.querySelectorAll('[data-st-reveal]').forEach(add);
    document.querySelectorAll('[data-st-stagger] > *').forEach(add);
    if (!items.length) return;
    onFrame(function () {
      if (!items.length) return;
      var line = vh * 0.92;
      var perParent = new Map();
      items = items.filter(function (el) {
        if (el.getBoundingClientRect().top - 12 > line) return true;
        var n = perParent.get(el.parentNode) || 0;
        perParent.set(el.parentNode, n + 1);
        var d = Math.min(n, 3) * 0.06;
        el.style.setProperty('--st-d', d + 's');
        el.classList.add('st-in');
        el.classList.remove('st-pre');
        window.setTimeout(function () {
          el.classList.remove('st-in');
          el.style.removeProperty('--st-d');
        }, (d + 0.9) * 1000);
        return false;
      });
    });
  }

  /* ---------- Press feedback ---------- */
  function initPress() {
    var PRESS = '.st-btn, .av-btn, .ac-btn, .button, .product-form__submit, .av-hdr-cart';
    var pressed = null, squeeze = null;
    function release() {
      if (!pressed) return;
      if (squeeze) squeeze.cancel();
      pressed.animate([{ scale: '0.98' }, { scale: '1' }], { duration: 260, easing: 'ease-out' });
      pressed = squeeze = null;
    }
    document.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      var el = e.target.closest && e.target.closest(PRESS);
      if (!el || el.disabled) return;
      release();
      pressed = el;
      squeeze = el.animate([{ scale: '1' }, { scale: '0.98' }], { duration: 100, easing: 'ease-out', fill: 'forwards' });
    }, { passive: true });
    ['pointerup', 'pointercancel', 'dragstart'].forEach(function (t) { document.addEventListener(t, release, { passive: true }); });
  }

  /* ---------- Cart count pop ---------- */
  function initCartPop() {
    var holder = document.getElementById('cart-icon-bubble');
    if (!holder || !('MutationObserver' in window)) return;
    function count() {
      var b = holder.querySelector('.cart-count-bubble [aria-hidden="true"]');
      return b ? b.textContent.trim() : '0';
    }
    var last = count();
    new MutationObserver(function () {
      var now = count();
      if (now === last) return;
      last = now;
      var bubble = holder.querySelector('.cart-count-bubble');
      if (bubble) bubble.animate([{ scale: '0.6' }, { scale: '1.15', offset: 0.6 }, { scale: '1' }], { duration: 420, easing: 'ease-out' });
    }).observe(holder, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 10-stick product page: any number of paid packs ----------
     One state: the number of PAID packs. The offer tiles set it (1, 3, 5,
     7); the − / + control sets any other number. Free packs follow the
     offers' tiers (snippets/alon-bundle-options, data-tiers "3:1,5:2,7:3"):
     the highest offer whose "buy" count is reached, never more than the
     largest offer's free count. Packs already in the cart are part of the
     sum, so adding to them tops the order up to the right free count.
     What Shopify charges comes from its automatic Buy X get Y discounts
     (one use per order each, not combinable with each other), which give
     exactly these free counts for the cart's total quantity. The result is
     written into the form's existing quantity field (data-alon-bundle-qty)
     through the matching tile or the hidden "custom" radio, so the product
     form and the mobile sticky bar keep working as they do with the tiles. */
  function initBundleQty() {
    document.querySelectorAll('[data-ab-qty]').forEach(function (box) {
      var fieldset = box.closest('[data-alon-bundles]');
      var input = box.querySelector('[data-ab-paid]');
      var custom = fieldset && fieldset.querySelector('[data-ab-custom]');
      if (!fieldset || !input || !custom) return;
      var customLabel = custom.closest('label');
      var hidden = fieldset.querySelector('[data-alon-bundle-qty]');
      var line = box.querySelector('[data-ab-line]');
      var note = box.querySelector('[data-ab-note]');
      var price = parseInt(box.getAttribute('data-price'), 10) || 0;
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 100000;
      var variantId = String(box.getAttribute('data-variant'));
      var money = box.getAttribute('data-money') || '₪[n]';
      var tiers = (box.getAttribute('data-tiers') || '').split(',').filter(Boolean).map(function (t) {
        var p = t.split(':');
        return { buy: parseInt(p[0], 10) || 0, get: parseInt(p[1], 10) || 0 };
      }).filter(function (t) { return t.buy > 0 && t.get > 0; });
      var maxGet = tiers.reduce(function (m, t) { return Math.max(m, t.get); }, 0);
      /* Labels in the storefront's language (snippets/alon-bundle-options). */
      var S = { paid: 'משלמים על', gift: 'במתנה', total: 'מקבלים סה״כ', pay: 'לתשלום', save: 'חוסכים', cap: 'עד [n] מארזים במתנה בכל הזמנה', inCart: 'החישוב כולל [packs] שכבר בסל.', noStock: 'אין כרגע מספיק מארזים במלאי.', one: 'מארז אחד', other: '[n] מארזים' };
      try { var given = JSON.parse(box.getAttribute('data-strings') || '{}'); Object.keys(given).forEach(function (k) { if (given[k]) S[k] = given[k]; }); } catch (e) { /* keep the defaults */ }
      var tiles = Array.prototype.slice.call(fieldset.querySelectorAll('[data-alon-qty]:not([data-ab-custom])'));
      var inCart = 0;
      var paid = 1;
      var lastAdd = 1;
      var syncing = false;

      function freeForPaid(p) { var f = 0; tiers.forEach(function (t) { if (p >= t.buy) f = Math.max(f, t.get); }); return f; }
      function freeInCart(q) { var f = 0; tiers.forEach(function (t) { if (q >= t.buy + t.get) f = Math.max(f, t.get); }); return f; }
      function fmt(cents) {
        var v = cents / 100;
        var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return money.replace('[n]', s);
      }
      function packs(n) { return n === 1 ? S.one : S.other.replace('[n]', n); }
      function plan(p) {
        var cartPaid = inCart - freeInCart(inCart);
        var totalPaid = cartPaid + p;
        var add = Math.max(p, totalPaid + freeForPaid(totalPaid) - inCart);
        return { paid: p, add: add, free: add - p, total: p * price, saving: (add - p) * price };
      }
      function maxPaid() {
        var avail = limit - inCart;
        if (avail < 1) return 0;
        var p = Math.max(1, avail - maxGet);
        while (p > 1 && plan(p).add > avail) p--;
        while (p < 999 && plan(p + 1).add <= avail) p++;
        return plan(p).add <= avail ? p : 0;
      }
      function tileBuy(t) { return price ? Math.round((parseInt(t.getAttribute('data-total'), 10) || 0) / price) : 0; }
      function fire(el) { el.dispatchEvent(new Event('change', { bubbles: true })); }

      function render() {
        var mx = maxPaid();
        paid = Math.min(Math.max(1, paid), Math.max(1, mx));
        input.value = String(paid);
        input.max = String(Math.max(1, mx));
        var r = plan(paid);
        var tile = tiles.filter(function (t) { return !t.disabled && tileBuy(t) === paid; })[0];
        syncing = true;
        if (tile) {
          if (!tile.checked) { tile.checked = true; fire(tile); }
        } else {
          custom.value = String(r.add);
          custom.setAttribute('data-total', String(r.total));
          custom.setAttribute('data-total-label', fmt(r.total));
          custom.setAttribute('data-regular', String(r.add * price));
          custom.setAttribute('data-regular-label', fmt(r.add * price));
          var short = r.free > 0 ? packs(r.add) + ' · ' + paid + ' + ' + r.free : packs(r.add);
          customLabel.setAttribute('data-alon-short', short);
          var bdi = customLabel.querySelector('bdi');
          if (bdi) bdi.textContent = short;
          custom.checked = true;
          fire(custom);
        }
        syncing = false;

        if (line) {
          /* Paid, gift and received side by side, then what is paid. */
          var html = r.free > 0
            ? '<dl class="ab-qty__break">' +
                '<div><dt>' + S.paid + '</dt><dd>' + packs(paid) + '</dd></div>' +
                '<div class="is-gift"><dt>' + S.gift + '</dt><dd>' + packs(r.free) + '</dd></div>' +
                '<div class="is-total"><dt>' + S.total + '</dt><dd>' + packs(r.add) + '</dd></div>' +
              '</dl>' +
              '<p class="ab-qty__pay">' + S.pay + ' <strong><bdi>' + fmt(r.total) + '</bdi></strong><span class="ab-qty__save">' + S.save + ' <bdi>' + fmt(r.saving) + '</bdi></span></p>'
            : '<p class="ab-qty__pay">' + packs(paid) + ' · ' + S.pay + ' <strong><bdi>' + fmt(r.total) + '</bdi></strong></p>';
          var orderFree = freeForPaid(inCart - freeInCart(inCart) + paid);
          if (maxGet > 0 && orderFree >= maxGet) html += '<p class="ab-qty__cap">' + S.cap.replace('[n]', maxGet) + '</p>';
          line.innerHTML = html;
        }
        if (note) {
          var msg = '';
          if (mx === 0) msg = S.noStock;
          else if (inCart > 0) msg = S.inCart.replace('[packs]', packs(inCart));
          note.textContent = msg;
          note.hidden = !msg;
        }
        box.querySelector('[data-ab-step="-1"]').disabled = paid <= 1;
        box.querySelector('[data-ab-step="1"]').disabled = paid >= mx;
        lastAdd = r.add;
        if (hidden) hidden.value = String(r.add);
        /* Again after the tile/radio handlers (alon-shop.js) copy the radio value. */
        window.setTimeout(function () { if (hidden) hidden.value = String(lastAdd); }, 0);
      }

      fieldset.addEventListener('change', function (e) {
        if (syncing) return;
        var t = e.target;
        if (t && t.matches && t.matches('[data-alon-qty]') && !t.hasAttribute('data-ab-custom')) {
          paid = tileBuy(t) || 1;
          render();
        }
      });
      box.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-ab-step]');
        if (!b || b.disabled) return;
        paid += parseInt(b.getAttribute('data-ab-step'), 10) || 0;
        render();
      });
      input.addEventListener('change', function () {
        paid = parseInt(input.value, 10) || 1;
        render();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      });

      function refreshCart() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.items) return;
            inCart = cart.items.reduce(function (s, i) { return String(i.variant_id) === variantId ? s + i.quantity : s; }, 0);
            render();
          })
          .catch(function () {});
      }
      var checked = fieldset.querySelector('[data-alon-qty]:checked:not([data-ab-custom])');
      if (checked) paid = tileBuy(checked) || 1;
      render();
      refreshCart();
      document.addEventListener('alon:cart-added', refreshCart);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { window.setTimeout(refreshCart, 150); });
      }
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
      /* The quantity the form posts is set once more at the moment of
         purchase (add to cart, or the express checkout button). */
      document.addEventListener('submit', function (e) {
        if (hidden && e.target && e.target.id && e.target.id === hidden.getAttribute('form')) hidden.value = String(lastAdd);
      }, true);
      document.addEventListener('click', function (e) {
        if (hidden && e.target.closest && e.target.closest('.shopify-payment-button')) hidden.value = String(lastAdd);
      }, true);
    });
  }

  /* ---------- Loop ---------- */
  var queued = false;
  function run() {
    if (!queued) return;
    queued = false;
    var y = window.scrollY;
    for (var i = 0; i < tasks.length; i++) {
      try { tasks[i](y); } catch (err) { /* one failing task never stops the others */ }
    }
  }
  // rAF normally; a timer as well, because rAF stops in hidden or throttled
  // tabs and a reveal must never stay pending.
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
    window.setTimeout(run, 160);
  }

  /* Section videos (snippets/alon-studio-media): muted loops that play
     only on screen and only when motion is allowed; the photo under them
     shows until then. The button pauses and resumes, and a pause sticks. */
  function initVideos() {
    var motionOff = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Array.prototype.forEach.call(document.querySelectorAll('video[data-st-video]'), function (v) {
      var btn = v.parentElement ? v.parentElement.querySelector('[data-st-video-toggle]') : null;
      var held = motionOff;
      v.muted = true;
      function paint() {
        var playing = !v.paused;
        if (!btn) return;
        btn.hidden = false;
        btn.classList.toggle('is-paused', !playing);
        btn.setAttribute('aria-label', playing ? btn.getAttribute('data-pause') : btn.getAttribute('data-play'));
      }
      function play() {
        v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () { paint(); });
      }
      v.addEventListener('playing', function () { v.classList.add('is-playing'); paint(); });
      v.addEventListener('pause', paint);
      if (btn) {
        btn.addEventListener('click', function () {
          if (v.paused) { held = false; play(); } else { held = true; v.pause(); }
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !held) play();
            else if (!e.isIntersecting && !v.paused) v.pause();
          });
        }, { threshold: 0.25 }).observe(v);
      } else if (!held) {
        play();
      }
      paint();
    });
  }

  function start() {
    initHeader();
    initPacks();
    initReveals();
    initBundleQty();
    try { initVideos(); } catch (e) { /* the photos stay */ }
    if (canAnimate && !reduce) { initPress(); initCartPop(); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight; schedule(); }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
